<template>
  <div>
    <v-row v-if="statement.subjects.debtor">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о должнике (заявителе)
        </div>

        <Subject :statement="statement" :subject="statement.subjects.debtor" />
      </v-col>
    </v-row>

    <v-row v-if="statement.subjects.creditors.length">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о кредиторе (если кредиторов несколько, раздел заполняется в
          отношении каждого кредитора)
        </div>

        <Step2 :data="statement.subjects.creditors" />
      </v-col>
    </v-row>

    <v-row v-if="statement.acceptanceDepositStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о денежных средствах и обязательств
        </div>

        <Step3 :data="statement.acceptanceDepositStep3" />
      </v-col>
    </v-row>

    <v-row v-if="statement.debtorAccountBankDetails">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата должнику безналичных денежных средств,
          направленных в депозит нотариуса
        </div>

        <BankDetails :data="statement.debtorAccountBankDetails" />
      </v-col>
    </v-row>

    <v-row v-if="statement.acceptanceDepositStep5">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>

        <StepRequisites
          :data="statement.acceptanceDepositStep5"
          :statement-type="StatementType.ACCEPTANCE_DEPOSIT"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/AcceptanceDeposit/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/AcceptanceDeposit/Step3';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import BankDetails from '@/components/elements/statement/FullStatementView/elements/BankDetails';
import { StatementType } from '@/types/services';

export default {
  name: 'AcceptanceDeposit',
  components: {
    Subject,
    Step2,
    Step3,
    BankDetails,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    StatementType,
  }),
};
</script>
